import {
  Validators,
  type AbstractControl,
  type ValidationErrors,
} from '@angular/forms';

export function requiredValidator(
  _: AbstractControl,
  value: unknown,
): ValidationErrors | null {
  return Validators.required({
    value,
  } as AbstractControl);
}
